// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--g1cyU","phone":"a10a3f92e9--phone--NuAXX"};